<template>
  <BaseBreadcrumb :items="breadcrumbs" />
  <div class="p-d-flex p-ai-center heading">
    <div class="p-mr-1"><h1>Email Templates</h1></div>
    <div>
      <Button
        label="Create"
        icon="pi pi-plus"
        class="p-button-rounded p-button-text p-button-sm"
        @click="$router.push({ name: 'EmailCreate' })"
      />
    </div>
  </div>

  <BaseTable
    :data="emails"
    :columns="columns"
    @update="goToUpdate"
    @delete="deleteDocument"
    @enable="enableDocument"
  />
  <ConfirmDialog
    :display="displayConfirmDelete"
    :disable="disableConfirmButton"
    @confirm="confirm"
    @display="display"
    :message="'Are you sure you want to disable?'"
  />
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import BaseTable from '@/components/BaseTable'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { useDeleteDocument } from '@/composables/useDeleteDocument'
import Button from 'primevue/button.js'
import { useToast } from 'primevue/usetoast.js'
import { firestore } from '@/services/firebase'
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'

export default {
  components: { BaseTable, ConfirmDialog, Button, BaseBreadcrumb },
  setup() {
    const emails = ref([])
    const toast = useToast()
    const router = useRouter()
    const {
      disableConfirmButton,
      displayConfirmDelete,
      deleteDocument,
      documentId
    } = useDeleteDocument()
    const columns = ref([
      { field: 'name', header: 'Name' },
      { field: 'subject', header: 'Subject' }
    ])
    const breadcrumbs = [{ label: 'Email Templates' }]

    function getEmailTemplates() {
      firestore
        .collection('handlebar')
        .get()
        .then(querySnapshot => {
          emails.value = []
          querySnapshot.forEach(doc => {
            const row = doc.data()
            row.id = doc.id
            emails.value.push(row)
          })
        })
    }

    function updateDocument(params, msg) {
      firestore
        .collection('handlebar')
        .doc(documentId.value)
        .set(params, { merge: true })
        .then(() => {
          getEmailTemplates()
          displayConfirmDelete.value = false
          disableConfirmButton.value = false
          toast.add({
            severity: 'success',
            summary: 'Success Message',
            detail: msg,
            life: 3000
          })
        })
        .catch(error => {
          toast.add({
            severity: 'error',
            summary: 'Failed',
            detail: error.message,
            life: 3000
          })
        })
    }

    function confirm() {
      disableConfirmButton.value = true
      updateDocument({ active: false }, 'Email Template successfully deleted')
    }

    function display(value) {
      displayConfirmDelete.value = value
    }

    function goToUpdate(id) {
      router.push({
        name: 'EmailUpdate',
        params: { id }
      })
    }

    function enableDocument(id) {
      documentId.value = id
      updateDocument({ active: true }, 'Email Template successfully enabled')
    }

    getEmailTemplates()

    return {
      emails,
      columns,
      displayConfirmDelete,
      disableConfirmButton,
      deleteDocument,
      confirm,
      display,
      goToUpdate,
      enableDocument,
      breadcrumbs
    }
  }
}
</script>

<style lang="scss" scoped>
.heading {
  margin: 0.83rem 0;
  h1 {
    margin: 0;
  }
}
</style>
